const CarteAdresse = ({ nom, adresse, ville }) => {
  const fullAdresse = `${adresse}, ${ville}`;
  const encodedAdresse = encodeURIComponent(fullAdresse);
  const url = `https://www.google.com/maps?q=${encodedAdresse}&output=embed`;

  return (
    <div className="map-container" style={{ width: '100%', height: '300px' }}>
      <h4>{nom}</h4>
      <iframe
        title={`Carte de ${fullAdresse}`}
        width="100%"
        height="100%"
        frameBorder="0"
        src={url}
        allowFullScreen
        loading="lazy"
      ></iframe>
    </div>
  );
};

export default CarteAdresse;